"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROICalculatorControls = exports.withBackgroundDummyElement = exports.noBackgroundDummyElement = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var PropertyControls_1 = require("Project/QwilrEditor/RegistryElement/PropertyControls/PropertyControls");
exports.noBackgroundDummyElement = { data: {} };
exports.withBackgroundDummyElement = { data: { backgroundImageUrl: "image" } };
var ROICalculatorControls = function (_a) {
    var properties = _a.properties, style = _a.style, onChangeHandler = _a.onChangeHandler;
    var unconditionalProperties = properties.filter(function (p) { return !p.if; });
    var noBackground = properties.filter(function (p) { return !!p.if && p.if({}, exports.noBackgroundDummyElement); });
    var withBackground = properties.filter(function (p) { return !!p.if && p.if({}, exports.withBackgroundDummyElement); });
    var commonProps = { style: style, onChangeHandler: onChangeHandler };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        unconditionalProperties.map(function (p) {
            return react_1.default.createElement(PropertyControls_1.PropertyControls, __assign({ key: p.path, property: p, target: "blockStyle" }, commonProps));
        }),
        react_1.default.createElement(kaleidoscope_1.Stack, { paddingTop: "m" },
            react_1.default.createElement(kaleidoscope_1.Label, { secondary: true, size: "s" }, "Without background image")),
        noBackground.map(function (p) {
            return react_1.default.createElement(PropertyControls_1.PropertyControls, __assign({ key: p.path, property: p, target: exports.noBackgroundDummyElement }, commonProps));
        }),
        react_1.default.createElement(kaleidoscope_1.Stack, { paddingTop: "m" },
            react_1.default.createElement(kaleidoscope_1.Label, { secondary: true, size: "s" }, "With background image")),
        withBackground.map(function (p) {
            return react_1.default.createElement(PropertyControls_1.PropertyControls, __assign({ key: p.path, property: p, target: exports.withBackgroundDummyElement }, commonProps));
        })));
};
exports.ROICalculatorControls = ROICalculatorControls;
